import React from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
export interface IOption {
    value: any;
    text: string;
}

interface ISelectInputSimpleProps {
    name: string;
    options: IOption[];
    onChange?: (event: React.ChangeEvent<HTMLElement>) => void;
    hasDefaultOption?: boolean;
    defaultOption?: string;
    value?: string | number;
}

const SelectInputSimple = ({
    name,
    options,
    onChange,
    hasDefaultOption,
    defaultOption,
    value,
}: ISelectInputSimpleProps) => {
    const intl = useIntl();
    return (
        <select
            name={name}
            value={value ? value : ''}
            onChange={onChange}
            className="form-control"
        >
            {hasDefaultOption && (
                <option value="">
                    {defaultOption &&
                        intl.formatMessage({
                            id: defaultOption.replace(/ /g, '_'),
                        })}
                </option>
            )}
            {options.map((option) => {
                return (
                    <option key={option.value} value={option.value}>
                        {option.text}
                    </option>
                );
            })}
        </select>
    );
};

export default SelectInputSimple;
